import {
  TopicRequest,
  TopicRequestBuilder
} from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils/TopicRequestBuilder';
import _cloneDeep from 'lodash/cloneDeep';

export type BeaconTopicExportType =
  | 'GroupByProductTopics'
  | 'GroupByBrandTopics'
  | 'GroupByCategoryTopics'
  | 'GroupBySubcategoryTopics'
  | 'GroupByBrandSubcategoryTopics'
  | 'GroupByKeywordTopics'
  | 'GroupByBrandKeywordTopics'
  | 'GroupByCampaignKeywordTopics'
  | 'GroupByProductKeywordTopics';

export interface TopicExportRequest extends TopicRequest {
  exportType: BeaconTopicExportType;
  comparisonStartWeekId?: number;
  comparisonEndWeekId?: number;
  fileName: string;
  columnDelimiter: string;
  requestSource: string;
  shouldGroupByWeek?: boolean;
}

export class TopicExportRequestBuilder extends TopicRequestBuilder {
  protected request: TopicExportRequest;

  constructor(baseRequest?: TopicExportRequest) {
    super(baseRequest);
    this.request = baseRequest
      ? _cloneDeep(baseRequest)
      : {
          ...this.request,
          exportType: null,
          fileName: 'export_file',
          columnDelimiter: ',',
          requestSource: 'source',
          shouldGroupByWeek: false
        };
  }

  public setExportType(exportType: BeaconTopicExportType): TopicExportRequestBuilder {
    this.request.exportType = exportType;
    return this;
  }

  public setComparisonStartWeekId(comparisonStartWeekId: number): TopicExportRequestBuilder {
    this.request.comparisonStartWeekId = comparisonStartWeekId;
    return this;
  }

  public setComparisonEndWeekId(comparisonEndWeekId: number): TopicExportRequestBuilder {
    this.request.comparisonEndWeekId = comparisonEndWeekId;
    return this;
  }

  public setFileName(fileName: string): TopicExportRequestBuilder {
    this.request.fileName = fileName;
    return this;
  }

  public setColumnDelimiter(columnDelimiter: string): TopicExportRequestBuilder {
    this.request.columnDelimiter = columnDelimiter;
    return this;
  }

  public setRequestSource(requestSource: string): TopicExportRequestBuilder {
    this.request.requestSource = requestSource;
    return this;
  }

  public setShouldGroupByWeek(shouldGroupByWeek: boolean): TopicExportRequestBuilder {
    this.request.shouldGroupByWeek = shouldGroupByWeek;
    return this;
  }

  private validateRequest(): void {
    const requiredFields = ['startWeekId', 'endWeekId', 'topicIds', 'exportType'];
    const missingFields = requiredFields.filter((field) => !this.request[field]);
    if (missingFields.length) {
      throw new Error(`Missing required fields in export request: ${missingFields.join(', ')}`);
    }
  }

  public build(): TopicExportRequest {
    this.validateRequest();
    return this.request;
  }
}
